import { Link } from "@tanstack/react-router";
import { CalendarDays } from "lucide-react";

const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.79-1.31l-.34-.2-3.56.93.95-3.47-.22-.36a9.37 9.37 0 0 1-1.44-5.01c0-5.18 4.23-9.4 9.42-9.4a9.35 9.35 0 0 1 6.65 2.76 9.31 9.31 0 0 1 2.76 6.65c0 5.18-4.23 9.41-9.42 9.41zM20.42 3.66A11.28 11.28 0 0 0 12.05.5C5.84.5.79 5.54.79 11.74c0 1.98.52 3.92 1.5 5.62L.7 23.5l6.29-1.64a11.25 11.25 0 0 0 5.06 1.21h.01c6.2 0 11.25-5.04 11.25-11.24 0-3-1.17-5.83-3.3-7.95z" />
  </svg>
);

const WHATSAPP_URL = "https://wa.me/5511963242299?text=" + encodeURIComponent("Olá, estou no site https://op2p.ai e gostaria de conversar sobre Agentes de IA");

const WHATSAPP_GREEN = "hsl(160 84% 45%)";


export function FloatingButtons() {
  return (
    <div className="fixed bottom-3 inset-x-0 flex items-center justify-center gap-2 sm:inset-x-auto sm:right-4 sm:bottom-20 sm:justify-end xl:right-5 z-50 pointer-events-none">
      <Link
        to="/agenda"
        aria-label="Agende uma reunião"
        className="pointer-events-auto h-12 w-12 rounded-full bg-primary text-white shadow-lg hover:opacity-90 transition-all duration-300 flex items-center justify-center"
      >
        <CalendarDays className="w-5 h-5 text-white" />
      </Link>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Nos chame no WhatsApp"
        className="pointer-events-auto relative h-12 pl-4 pr-5 rounded-full text-white text-sm font-bold shadow-[0_4px_20px_hsla(160,84%,45%,0.5)] hover:shadow-[0_4px_30px_hsla(160,84%,45%,0.7)] hover:scale-[1.02] transition-all duration-300 flex items-center gap-2"
        style={{ backgroundColor: WHATSAPP_GREEN }}
      >
        <WhatsAppIcon className="w-5 h-5 relative z-10" />
        <span className="relative z-10">Nos chame no WhatsApp</span>
      </a>
    </div>
  );
}

export const WHATSAPP_LINK = WHATSAPP_URL;
export const CALENDLY_LINK = "/agenda";

export const WHATSAPP_TRIAL_LINK =
  "https://wa.me/5511963242299?text=" +
  encodeURIComponent(
    "Olá! Vim do site https://op2p.ai e gostaria de solicitar uma POC de 7 dias dos Agentes de IA da OP2P. Pode me ajudar?"
  );

export const WHATSAPP_SUPPORT_LINK =
  "https://wa.me/5511963242299?text=" +
  encodeURIComponent(
    "Olá! Vim do site https://op2p.ai e preciso de suporte com os Agentes de IA da OP2P. Podem me ajudar?"
  );
